import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zM191.9 291.7c0 14.6-11.9 26.5-26.5 26.5-14.9 0-26.8-11.9-26.8-26.5 0-14.9 11.9-26.8 26.8-26.8 14.6 0 26.5 11.9 26.5 26.8zM282.6 264.9c14.9 0 26.8 11.9 26.8 26.8 0 14.6-11.9 26.5-26.8 26.5-14.6 0-26.5-11.9-26.5-26.5 0-14.9 11.9-26.8 26.5-26.8zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM348.3 220.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-0.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-0.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z'
      }
    ]
  }
})
